export class DeleteGroupAlertController {
    static $inject = ['close', 'deleteGroup', 'groupId', 'groupName', 'trackGiveUp'];
    constructor(close, deleteGroup, groupId, groupName, trackGiveUp) {
        this.close = close;
        this.deleteGroup = deleteGroup;
        this.groupId = groupId;
        this.groupName = groupName;
        this.trackGiveUp = trackGiveUp;
        this.closeModal = (shouldTrack = true) => {
            if (shouldTrack) {
                this.trackGiveUp(this.groupId);
            }
            this.close();
        };
        this.onModalChanged = (event) => {
            if (event.detail.modalStatus === 'closed') {
                this.closeModal();
            }
        };
        this.deleteGroupConfirm = async () => {
            this.closeModal(false);
            await this.deleteGroup(this.groupId);
        };
        this.name = this.groupName;
    }
    $onInit() {
        document
            .getElementById('whatsapp-groups-delete-alert')
            .addEventListener('bdsModalChanged', this.onModalChanged);
    }
}
DeleteGroupAlertController.$inject = ['close', 'deleteGroup', 'groupId', 'groupName', 'trackGiveUp'];
